/* Lawazen Next - Trotec machine finder. Build 2026-09-06-p2b
   Every step and every candidate machine is rendered by Liquid. This file only
   walks the steps and decides which candidates survive, so no markup is built
   in JavaScript and the section stays fully editable in the theme editor. */
(function () {
  'use strict';

  function finder(root) {
    if (root.dataset.lzBound) return; root.dataset.lzBound = '1';

    var steps = [].slice.call(root.querySelectorAll('[data-lz-step]'));
    var result = root.querySelector('[data-lz-result]');
    var cards = [].slice.call(root.querySelectorAll('[data-lz-family]'));
    var noMatch = root.querySelector('[data-lz-nomatch]');
    var answersOut = root.querySelector('[data-lz-answers]');
    var counter = root.querySelector('[data-lz-counter]');
    var backBtn = root.querySelector('[data-lz-tf-back]');
    var nextBtn = root.querySelector('[data-lz-tf-next]');
    var restart = root.querySelector('[data-lz-tf-restart]');
    if (!steps.length || !result) return;

    var rules = {};
    try { rules = JSON.parse(root.dataset.lzRules || '{}'); } catch (e) { rules = {}; }

    var at = 0;

    function answers() {
      var out = {};
      steps.forEach(function (s) {
        var picked = s.querySelector('input:checked');
        if (picked) out[s.dataset.lzStep] = picked.value;
      });
      return out;
    }

    function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

    function wanted(a) {
      if (a.process && a.process === rules.marking) return rules.familiesMarking || [];
      if (a.process && a.process === rules.cutting && a.material === rules.bare) return null;
      if (a.format && a.format === rules.large) return rules.familiesLarge || [];
      return rules.familiesDefault || [];
    }

    function render() {
      steps.forEach(function (s, i) { s.hidden = at !== i || at >= steps.length; });
      var finished = at >= steps.length;
      result.hidden = !finished;
      if (backBtn) backBtn.hidden = finished || at === 0;
      if (nextBtn) nextBtn.hidden = finished;
      if (counter) { counter.hidden = finished; counter.textContent = (at + 1) + ' / ' + steps.length; }
      if (!finished) return;

      var a = answers();
      if (answersOut) answersOut.textContent = Object.keys(a).map(function (k) { return a[k]; }).join('  ·  ');

      var fam = wanted(a);
      var keys = (fam || []).map(norm).filter(Boolean);
      var hits = 0;
      cards.forEach(function (c) {
        var hay = norm(c.dataset.lzFamily);
        var ok = fam !== null && keys.some(function (k) { return hay.indexOf(k) > -1; });
        c.hidden = !ok;
        if (ok) hits++;
      });
      if (noMatch) noMatch.hidden = hits > 0;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type=radio]') && nextBtn) nextBtn.disabled = false;
    });

    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var current = steps[at];
      if (current && !current.querySelector('input:checked')) {
        var first = current.querySelector('input');
        if (first) first.focus();
        return;
      }
      at = Math.min(at + 1, steps.length);
      render();
    });

    if (backBtn) backBtn.addEventListener('click', function (e) {
      e.preventDefault(); at = Math.max(0, at - 1); render();
    });

    if (restart) restart.addEventListener('click', function (e) {
      e.preventDefault();
      root.querySelectorAll('input[type=radio]').forEach(function (i) { i.checked = false; });
      at = 0; render();
    });

    render();
  }

  window.lzFinderInit = function (scope) {
    (scope || document).querySelectorAll('[data-lz-tf]').forEach(finder);
  };
  if (window.lzInit) window.lzFinderInit(document);
})();
